
import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, FileText, Shield, Scale } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface LegalLayoutProps {
  title: string;
  icon: React.ReactNode;
  lastUpdated?: string;
  children: React.ReactNode;
}

const LegalLayout = ({ title, icon, lastUpdated, children }: LegalLayoutProps) => {
  return (
    <div className="min-h-screen bg-surface-mild py-12">
      <div className="container max-w-4xl px-4">
        {/* Back Navigation */}
        <Button variant="ghost" className="mb-6" asChild>
          <Link to="/">
            <ChevronLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Link>
        </Button>
        
        <Card className="border shadow-sm bg-white">
          <CardContent className="p-8">
            {/* Header */}
            <div className="flex items-center mb-6">
              <div className="bg-primary/10 p-2 rounded-full mr-3">
                {icon}
              </div>
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-primary">{title}</h1>
                {lastUpdated && (
                  <p className="text-sm text-muted-foreground">
                    Last updated: {lastUpdated}
                  </p>
                )}
              </div>
            </div>
            
            {/* Content */}
            <div className="prose prose-slate max-w-none">
              {children}
            </div>
          </CardContent>
        </Card>
        
        {/* Legal Navigation */}
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <Button variant="outline" asChild>
            <Link to="/privacy">
              <Shield className="h-4 w-4 mr-2" />
              Privacy Policy
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/terms">
              <Scale className="h-4 w-4 mr-2" />
              Terms of Service
            </Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/cookies">
              <FileText className="h-4 w-4 mr-2" />
              Cookie Policy
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LegalLayout;
